import { useTranslation } from 'react-i18next'

import { CredentialField, CredentialsCardProps, CredentialsFormCard } from './credentials-form-card'
import { useAccentraCredentials, useSaveAccentraCredentials } from './provider-connections'

export const AccentraCard = ({ buildingId, ...props }: CredentialsCardProps) => {
  const { t } = useTranslation(['organisation'])
  const { configured, isLoading } = useAccentraCredentials(buildingId)
  const { isPending, mutateAsync: save } = useSaveAccentraCredentials()

  const fields: CredentialField[] = [
    {
      error: t('organisation:places.integrations.accentra.errors.login'),
      label: t('organisation:places.integrations.accentra.fields.login.label'),
      name: 'login',
      placeholder: t('organisation:places.integrations.accentra.fields.login.placeholder'),
    },
    {
      error: t('organisation:places.integrations.accentra.errors.password'),
      label: t('organisation:places.integrations.accentra.fields.password.label'),
      name: 'password',
      placeholder: t('organisation:places.integrations.accentra.fields.password.placeholder'),
      secret: true,
    },
  ]

  return (
    <CredentialsFormCard
      {...props}
      configured={configured}
      fields={fields}
      isLoading={isLoading}
      isSaving={isPending}
      onSave={(values) => save({ buildingId, login: values.login, password: values.password })}
    />
  )
}
